import script from "./nav-tabs-simple.vue?vue&type=script&setup=true&lang=ts"
export * from "./nav-tabs-simple.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__